import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}>
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, children, light = false }) => (
  <Reveal className="mb-10 grid gap-6 lg:mb-14 lg:grid-cols-12 lg:items-end">
    <div className="lg:col-span-7">
      <p className={`mb-4 flex items-center gap-3 font-mono text-sm uppercase tracking-[0.22em] sm:text-[15px] ${light ? "text-[#6B5A2E]" : "text-zinc-300"}`}>
        <span className={`h-px w-10 shrink-0 ${light ? "bg-[#B8921F]" : "bg-accent2"}`} /> {eyebrow}
      </p>
      <h2 className={`font-display text-[1.85rem] font-bold uppercase leading-[0.95] tracking-[-0.02em] sm:text-5xl lg:text-6xl ${light ? "text-[#14110A]" : "text-white"}`}>{title}</h2>
    </div>
    {children && <div className={`text-base leading-relaxed lg:col-span-5 ${light ? "text-[#3F3A2E]" : "text-zinc-300"}`}>{children}</div>}
  </Reveal>
);
